import { chatwoot } from './chatwoot'
import type { Inbox } from '@/types/chatwoot'

interface InboxesResponse {
  payload: Inbox[]
}

export async function fetchInboxes(): Promise<Inbox[]> {
  const { data } = await chatwoot.get<InboxesResponse>('/inboxes')
  return data.payload
}
